/**
 * airan-ntn — Predictive Allocation xApp
 * Predicts load and pre-allocates resources
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class PredictiveAllocXApp extends XAppBase {
  private loadHistory: Map<number, number[]> = new Map();

  constructor(enabled: boolean = true) {
    super('predictive-alloc', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    const history = this.loadHistory.get(report.gnbId) ?? [];
    history.push(report.cellLoad);
    if (history.length > 20) history.shift();
    this.loadHistory.set(report.gnbId, history);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, history] of this.loadHistory) {
      if (history.length < 5) continue;
      const trend = history[history.length - 1] - history[0];
      if (trend > 0.2) {
        actions.push({
          type: 'PRB_RESERVATION',
          targetId: gnbId,
          payload: { reservePrbs: Math.min(20, Math.round(trend * 100)), horizon: 5 },
          priority: this.config.priority,
          timestamp: Date.now()
        });
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.75, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}